import React from 'react';
import styled from 'styled-components';
import * as BuilderUI from '../../BuilderUI';
import { useAppSelector } from '../../../../redux/hooks';
import { builderSelectedOptionsSelector } from '../../../../redux/selectors/builder';
import { TimeUnit } from '../../../../utils/apollo/graphqlSchema';
import { getTimeUnitText } from '../../../../utils';

const TextWrapper = styled(BuilderUI.BuilderFieldLabel)`
  align-self: center;
  margin-right: 0;
`;

// Once selected, IN_EACH time window will also reflect the selected time unit
const CohortInEachTimeWindowValue = () => {
  const selectedOptions = useAppSelector(builderSelectedOptionsSelector);

  const timeUnit =
    selectedOptions && 'timeUnit' in selectedOptions
      ? selectedOptions.timeUnit
      : TimeUnit.Day;

  return <TextWrapper>{getTimeUnitText(timeUnit).singular}</TextWrapper>;
};

export default CohortInEachTimeWindowValue;
